// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__yrjVI","header":"ClearentDisclaimer_header__2BK5z","inner":"ClearentDisclaimer_inner__l8ulX"};